import { type MarketStatItemProps } from "#/components/MarketStatItem/MarketStatItem";
import { type FundingRate } from "#/types/funding";

export const getMarketStatItems = (
  currentFundingRate: FundingRate | undefined,
  previousFundingRate: FundingRate | undefined,
): MarketStatItemProps[] => [
  {
    config: {
      id: "previousHourly",
      label: "Previous hourly",
      variant: "percentage-indicator",
      precision: 3,
    },
    value: previousFundingRate ? previousFundingRate.rateHourly : Number.NaN,
  },
  {
    config: {
      id: "currentHourly",
      label: "Current hourly",
      variant: "percentage-indicator",
      precision: 3,
    },
    value: currentFundingRate ? currentFundingRate.rateHourly : Number.NaN,
  },
  {
    config: {
      id: "previousYearly",
      label: "Previous yearly",
      variant: "percentage-indicator",
      precision: 2,
    },
    value: previousFundingRate ? previousFundingRate.rateYearly : Number.NaN,
  },
  {
    config: {
      id: "currentYearly",
      label: "Current yearly",
      variant: "percentage-indicator",
      precision: 2,
    },
    value: currentFundingRate ? currentFundingRate.rateYearly : Number.NaN,
  },
];
